import { render, staticRenderFns } from "./IndexGeneric.vue?vue&type=template&id=5b382364&scoped=true&"
import script from "./IndexGeneric.vue?vue&type=script&lang=ts&"
export * from "./IndexGeneric.vue?vue&type=script&lang=ts&"
import style0 from "./IndexGeneric.vue?vue&type=style&index=0&id=5b382364&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b382364",
  null
  
)

export default component.exports